<app-layout></app-layout>
<!-- Alerts -->
<div *ngIf="showMessage" class="alert" [ngClass]="isError? 'alert-danger' : 'alert-success'" role="alert">
{{statusMessage}}
<button type="button" class="close" data-dismiss="alert" (click)="CloseMessage()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
</button>
</div>
<!-- Alerts -->